export default __webpack_public_path__ + "e15119c8f20bed3068586c97cf59b7ab.png";